import api from '@/api'
import { USER_INFO, HAD_TAB_LOGIN } from '@/store/mutation-types'
import { WITH_LOADING } from '@/store/action-types'
const qs = require('qs')
const user = {
  namespaced: true,
  state () {
    return {
      info: null,
      hadTabLogin: false
    }
  },
  getters: {
    info: state => state.info,
    isLogin: state => {
      const { info } = state
      // 要通過帳密驗證(已有session)，還有OTP驗證 才會進入首頁
      return info && !!info.userCode && info.otpValidate // 登入session 與 otp驗證
    },
    checkTabBlock: state => {
      // const { info } = state
      // if (info && info.carryYn === 'Y') {
      //  return false
      // }
      // return info && !!info.checkTabBlock
      return true
    }
  },
  mutations: {
    [USER_INFO] (state, info) {
      state.info = info
    },
    [HAD_TAB_LOGIN] (state, hadTabLogin) {
      state.hadTabLogin = hadTabLogin
    }
  },
  actions: {
    login: ({ dispatch }, payload) => {
      const action = api
        .post('/login', qs.stringify(payload), {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          timeout: 16000,
          validateStatus: function (status) {
            return true
          }
        })
        .then(r => {
          if (r.status === 200) {
            sessionStorage.setItem('randomPageId', r.data.randomPageId)
            return dispatch('fetchUserInfo').then(() => r)
          } else {
            return r
          }
        })
        .catch(e => {})
      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    logout: ({ commit, dispatch }, payload) => {
      const params = payload
      commit(USER_INFO, null)
      console.log('logout')
      const action = api
        .post('/logout', qs.stringify(payload), {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          validateStatus: function (status) {
            return true
          }
        }).then(() => {
          console.log('after logout')
          window.location.reload()
        }).catch(() => {
          console.log('after logout')
          window.location.reload()
        })
      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    fetchCaptcha: ({ dispatch }) => {
      const action = api.get('/captcha?noCache=Math.random()', {
        responseType: 'arraybuffer'
      })

      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    validateCaptcha: ({ commit, dispatch }, captchaCode) => {
      const action = api.post(
        '/captcha',
        {},
        {
          params: { captchaCode },
          validateStatus: function (status) {
            return true
          }
        }
      )
      return action
    },
    fetchUserInfo: ({ commit, dispatch }) => {
      const action = api
        .get('/public/userInfo', {
          validateStatus: function (status) {
            return true
          }
        })
        .then(r => {
          if (r.data) {
            commit(USER_INFO, r.data)
          } else {
            commit(USER_INFO, null)
          }
          return r
        })
      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    googleApiValidator: ({ dispatch }, payload) => {
      const action = api.post('/users/googleApiValidator', payload)
      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    featchBranCodeRole: ({ dispatch }, payload) => {
      const params = payload
      const action = api.get('/users/branCodeRole', { params }).then(r => {
        return r
      })
      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    changeBranCodeRole: ({ dispatch }, payload) => {
      const action = api.post('/users/branCodeRole', payload).then(r => {
        return r
      })
      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    vertifyRePawd: ({ dispatch }, payload) => { // 忘記密碼-驗證重新輸入密碼
      const action = api.post('public/forgetPawd/vertifyRePawd', payload)
      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    sendOtpCaptcha: ({ dispatch }, payload) => { // 忘記密碼-發送Otp
      const action = api.post('public/forgetPawd/sendOtpForgetPawdOtp', payload)
      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    verifyOtpCaptcha: ({ dispatch }, payload) => { // 忘記密碼-驗證Otp
      const action = api.post('public/forgetPawd/verifyForgetPawdOtp', payload)
      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    pwExpireSendMail: ({ dispatch }, payload) => { // 發送更改密碼通知EMAIL
      const action = api.post('public/forgetPawd/pwExpireSendMail', payload)
      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    loginOtpSendHendler: ({ dispatch }, payload) => { // 發送登入OTP驗証碼
      const action = api.post('/users/sendOtpLogin', payload).then(r => {
        return r
      })
      return dispatch(WITH_LOADING, { action }, { root: true })
    },
    loginOtpValidate: ({ dispatch }, payload) => { // 登入otp檢核
      const action = api.post('/users/verifyLoginOtp', payload).then(r => {
        return r
      })
      return dispatch(WITH_LOADING, { action }, { root: true })
    },


    checkTabLogin: ({ getters, commit }) => {
      if (getters.isLogin) {
        const checkTabBlock = getters.checkTabBlock
        const browserRandomPageId = sessionStorage.getItem('randomPageId')
        if (browserRandomPageId) {
          const infoRandomPageId = getters.info.randomPageId

          if (infoRandomPageId !== browserRandomPageId) {
            commit(HAD_TAB_LOGIN, (checkTabBlock && true))
          } else {
            commit(HAD_TAB_LOGIN, false)
          }
        } else {
          commit(HAD_TAB_LOGIN, (checkTabBlock && true))
        }
      }
    }
  }
}
export default user
